import { render, staticRenderFns } from "./metadata-analytics.vue?vue&type=template&id=22f98861&"
import script from "./metadata-analytics.vue?vue&type=script&lang=js&"
export * from "./metadata-analytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports